module.exports = __webpack_public_path__ + "static/img/icon-safe5.1757205.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-safe5.png
// module id = +2Fp
// module chunks = 21